import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import MMTConfigurationTable from "./MMTConfigurationTable";
import {
  getCorporateClients,
  getCorporateClientsBySeviceCityId,
  showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
const MMTConfiguration = () => {
  const { globalCityField, setShowApiLoader } = useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  useEffect(() => {
    fetchTableData();
  }, [globalCityField.value, pagination, rowsPerPage]);

  const fetchTableData = () => {
    const serviceCityId = globalCityField.value?.id || null;
    let obj = {
      serviceCityId: serviceCityId,
      page: pagination,
      size: rowsPerPage,
    };
    setLoader(true);
    if (serviceCityId) {
      getCorporateClientsBySeviceCityId(obj)
        .then((result) => {
          setPaginationTotalRows(result.data.count);
          setTableData(result.data.list);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          showAlert("error", "Something went wrong");
        });
    } else {
      getCorporateClients()
        .then((result) => {
          setTableData(result.data);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          showAlert("error", "Something went wrong");
        });
    }
  };
  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };
  return (
    <Fragment>
      <Breadcrumbs
        parent="Configuration"
        subParent="MMT Configuration"
        mainTitle="MMT Configuration"
        //   span1={
        //     <FilterTable
        //       options={columns}
        //       setFilterData={setFilterData}
        //       filterData={filterData}
        //       setSearchData={setSearchData}
        //       setFilterType={setFilterType}
        //       statusData={bookingStatusData}
        //       bookingViaTypeData={bookingViaTypeData}
        //     />
        //   }
        //   span3={
        //     <SearchTable
        //       searchData={searchData}
        //       setSearchData={setSearchData}
        //       setFilterData={setFilterData}
        //       setFilterType={setFilterType}
        //     />
        //   }
      />
      <Container fluid={true} className="datatables">
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                  <MMTConfigurationTable
                    fetchTableData={fetchTableData}
                    tableData={tableData}
                    setShowApiLoader={setLoader}
                    onChangePage={onChangePage}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    loader={loader}
                  />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default MMTConfiguration;
